/* ============================================================
   TTWN - DEFILEMENT DES PHOTOS PRODUIT A LA SOURIS
   ------------------------------------------------------------
   LE PROBLEME. Sur ordinateur, la pellicule des photos produit est
   un conteneur a defilement horizontal (.product__media-list, classe
   .slider de Dawn). Dawn n'affiche ses fleches que si la liste est
   marquee "slider--desktop" ; ici elle est "slider--mobile", donc
   au-dessus de 990 px les fleches sont masquees. Resultat : avec une
   souris, aucun moyen d'atteindre les photos suivantes - ni fleches,
   ni barre, et une souris ne fait pas defiler un conteneur en le
   tirant. Seul le clic pour agrandir repondait.

   CE QU'ON AJOUTE (etat au 14/10/2026) :
   - on tire la pellicule a la souris, clic maintenu + mouvement
     gauche/droite, avec un geste vif qui avance d'une photo ;
   - les fleches <- -> du clavier agissent des que la souris SURVOLE la
     photo, sans qu'il faille cliquer avant ;
   - l'agrandissement passe au DOUBLE-clic : un simple clic ouvrait la
     photo en grand et coupait court a tout geste de defilement.
   Les fleches a l'ecran de Dawn restent masquees (essayees le 13/10,
   retirees le 14/10 : trop presentes pour la page).

   QUATRE PIEGES, ET COMMENT ILS SONT TRAITES.

   1. Le clic doit continuer d'ouvrir l'agrandissement. On ne parle
      de glissement qu'au-dela de SEUIL pixels ; en dessous on ne
      touche a rien. Au-dela, on avale le clic qui suit le
      relachement, sinon lacher la souris ouvrirait la photo.

   2. DEUX reglages de la pellicule se liguent contre un glissement a
      la main, et il faut neutraliser les deux - mesure faite dans le
      navigateur, l'un seul ne suffit pas :
      - scroll-snap-type: x mandatory ramene la pellicule sur la photo
        la plus proche a chaque pixel qu'on lui impose ;
      - scroll-behavior: smooth transforme chaque affectation en
        animation, si bien que les affectations se marchent dessus et
        que rien n'avance.
      Les deux sont donc coupes des l'appui - pas au franchissement du
      seuil, sinon le premier deplacement est annule - et remis au
      relachement. Le lisse revient AVANT le calage final, qui glisse
      ainsi doucement vers la photo la plus proche.

   3. On ecoute le deplacement et le relachement sur WINDOW et non sur
      la pellicule. Si la souris sort du conteneur, ou si
      l'environnement n'emet pas tous les evenements de pointeur, on
      resterait sinon bloque en etat "en train de glisser" : accroche
      coupee et curseur en main fermee. La remise en etat se fait aussi
      sur mouseup et sur la perte de focus de la fenetre.

   4. Un petit coup sec (30 px en 60 ms) doit avancer d'une photo. Au
      relachement on mesure donc la vitesse sur les deux derniers points
      du geste : au-dela de VITESSE_LANCER on avance d'exactement une
      photo depuis celle d'ou l'on est parti, sinon on cale sur la plus
      proche. Sans cela un coup sec revenait en arriere.
   ============================================================ */
(function () {
  'use strict';

  if (window.ttwnMediaDragInstalled) return;
  window.ttwnMediaDragInstalled = true;

  var SEUIL = 6;          // px parcourus avant de parler de glissement
  var LARGEUR_MINI = 750; // en dessous, le doigt fait deja le travail
  var VITESSE_LANCER = 0.4; // px/ms : au-dela, on considere que l'on "lance"

  /* Etat du geste en cours. Un seul a la fois, d'ou des variables de
     module plutot qu'une fermeture par pellicule. */
  var liste = null;
  var glisse = false;
  var departX = 0;
  var departScroll = 0;
  var accrocheMemorisee = '';
  var lisseMemorise = '';
  /* Deux derniers points du geste, pour en deduire la vitesse au
     relachement (voir le point 4 en tete de fichier). */
  var avantX = 0;
  var avantT = 0;
  var dernierX = 0;
  var dernierT = 0;

  function estSouris() {
    if (window.innerWidth < LARGEUR_MINI) return false;
    if (!window.matchMedia) return true;
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  /* Largeur d'une photo, c'est-a-dire le pas de defilement. Mesure sur
     l'ecart entre les deux premieres photos quand il y en a plusieurs :
     cela prend en compte d'eventuelles marges. */
  function pasDe(el) {
    var items = el.querySelectorAll('.product__media-item');
    if (!items.length) return 0;

    var pas = 0;
    for (var i = 0; i < items.length; i++) {
      if (items[i].offsetWidth) { pas = items[i].offsetWidth; break; }
    }
    if (items.length > 1) {
      var ecart = items[1].offsetLeft - items[0].offsetLeft;
      if (ecart > 0) pas = ecart;
    }
    return pas;
  }

  /* Amene la pellicule sur la photo n, en douceur, sans jamais sortir
     des bornes. On le fait nous-memes : remettre scroll-snap ne
     provoque pas toujours un recalage. */
  function allerA(el, index) {
    var pas = pasDe(el);
    if (!pas) return;

    var dernier = Math.round((el.scrollWidth - el.clientWidth) / pas);
    if (index < 0) index = 0;
    if (index > dernier) index = dernier;

    var cible = index * pas;
    try {
      el.scrollTo({ left: cible, behavior: 'smooth' });
    } catch (e) {
      el.scrollLeft = cible;
    }
  }

  function terminer(caler) {
    if (!liste) return;

    var el = liste;
    liste = null;

    el.classList.remove('ttwn-media--glisse');

    /* Le lisse revient d'abord : le calage ci-dessous glisse alors
       doucement au lieu de sauter. */
    el.style.scrollBehavior = lisseMemorise || '';

    if (caler && glisse) {
      var pas = pasDe(el);
      var duree = dernierT - avantT;
      var vitesse = duree > 0 ? (dernierX - avantX) / duree : 0;

      /* Geste vif : on avance d'exactement une photo depuis celle d'ou
         l'on est parti, meme si le doigt n'a parcouru que 30 px. Sans
         cela, un petit coup sec revenait en arriere, ce qui donnait
         l'impression que la pellicule etait bloquee. */
      if (pas && Math.abs(vitesse) >= VITESSE_LANCER) {
        allerA(el, Math.round(departScroll / pas) + (vitesse < 0 ? 1 : -1));
      } else if (pas) {
        allerA(el, Math.round(el.scrollLeft / pas));
      }
    }

    /* L'accroche revient en DERNIER : remise avant le calage, elle se
       declencherait pendant le defilement doux et le couperait net. */
    setTimeout(function () {
      el.style.scrollSnapType = accrocheMemorisee || '';
    }, glisse ? 420 : 0);

    glisse = false;
  }

  document.addEventListener('pointerdown', function (event) {
    var el = event.target.closest && event.target.closest('.product__media-list');
    if (!el) return;
    if (!estSouris()) return;
    if (event.pointerType && event.pointerType !== 'mouse') return;
    if (event.button !== 0) return;
    if (el.scrollWidth <= el.clientWidth + 1) return; // rien a faire defiler

    liste = el;
    glisse = false;
    departX = event.clientX;
    departScroll = el.scrollLeft;
    avantX = event.clientX;
    avantT = event.timeStamp || Date.now();
    dernierX = avantX;
    dernierT = avantT;
    accrocheMemorisee = el.style.scrollSnapType;
    lisseMemorise = el.style.scrollBehavior;
    /* Coupes des maintenant, voir le piege 2 en tete de fichier. */
    el.style.scrollSnapType = 'none';
    el.style.scrollBehavior = 'auto';
  });

  window.addEventListener('pointermove', function (event) {
    if (!liste) return;

    var ecart = event.clientX - departX;

    if (!glisse) {
      if (Math.abs(ecart) < SEUIL) return;
      glisse = true;
      liste.classList.add('ttwn-media--glisse');
    }

    /* Sinon le navigateur lance son glisser-deposer d'image. */
    if (event.cancelable) event.preventDefault();
    liste.scrollLeft = departScroll - ecart;

    avantX = dernierX;
    avantT = dernierT;
    dernierX = event.clientX;
    dernierT = event.timeStamp || Date.now();
  });

  /* On avale le clic qui suit un vrai glissement, en phase de capture
     pour passer avant l'ouverture de l'agrandissement. */
  document.addEventListener(
    'click',
    function (event) {
      if (!glisse) return;
      if (!event.target.closest || !event.target.closest('.product__media-list')) return;
      event.stopPropagation();
      event.preventDefault();
    },
    true
  );

  /* ---------- fleches du clavier ----------
     Elles agissent sur la pellicule SURVOLEE par la souris, pas
     seulement sur celle qui a le focus : sans cela il fallait d'abord
     cliquer dans la galerie, ce que personne ne fait. */
  var survolee = null;

  /* Ces evenements se declenchent sur chaque element survole : des que
     la souris quitte la pellicule, closest renvoie null et la memoire
     s'efface d'elle-meme. On ecoute les deux familles d'evenements -
     pointerover et mouseover - parce que certains environnements
     n'emettent que l'une des deux. */
  function noterSurvol(event) {
    if (!event.target.closest) return;
    survolee = event.target.closest('.product__media-list');
  }

  document.addEventListener('pointerover', noterSurvol);
  document.addEventListener('mouseover', noterSurvol);

  window.addEventListener('blur', function () { survolee = null; });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    if (event.metaKey || event.ctrlKey || event.altKey) return;
    if (!estSouris()) return;

    /* Jamais pendant une saisie : Find my size, note du panier,
       recherche. Les fleches doivent y deplacer le curseur. */
    var actif = document.activeElement;
    if (actif && (actif.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(actif.tagName))) {
      return;
    }

    var el = (event.target.closest && event.target.closest('.product__media-list')) || survolee;
    if (!el) return;

    var pas = pasDe(el);
    if (!pas) return;

    event.preventDefault();
    allerA(el, Math.round(el.scrollLeft / pas) + (event.key === 'ArrowRight' ? 1 : -1));
  });

  /* ---------- agrandissement : double-clic au lieu du clic ----------
     Le simple clic ouvrait la photo en grand, donc tout geste de
     defilement finissait en plein ecran. On avale le clic sur le bouton
     d'agrandissement et on ne le rejoue que sur un double-clic.

     Trois precautions :
     - au doigt (estSouris faux), rien ne change : un appui ouvre
       toujours l'agrandissement, comme avant ;
     - un clic declenche au clavier (Entree, Espace) a event.detail a 0 :
       on le laisse passer, sinon la photo devient inatteignable sans
       souris ;
     - l'ecouteur est en phase de CAPTURE sur document, donc il passe
       avant celui que Dawn pose sur le bouton lui-meme (modal-opener,
       assets/global.js). */
  var clicRejoue = false;

  document.addEventListener(
    'click',
    function (event) {
      if (!estSouris()) return;
      if (!event.detail) return; // clavier
      if (clicRejoue) { clicRejoue = false; return; }

      if (!event.target.closest) return;
      if (!event.target.closest('.product__media-toggle')) return;

      event.preventDefault();
      event.stopPropagation();
    },
    true
  );

  document.addEventListener('dblclick', function (event) {
    if (!estSouris()) return;
    if (!event.target.closest) return;

    var bouton = event.target.closest('.product__media-toggle');
    if (!bouton) return;

    event.preventDefault();
    clicRejoue = true;
    bouton.click();
  });

  window.addEventListener('pointerup', function () { terminer(true); });
  window.addEventListener('pointercancel', function () { terminer(false); });
  window.addEventListener('mouseup', function () { terminer(true); });
  window.addEventListener('blur', function () { terminer(false); });
})();
